import { useNavigate } from "react-router-dom";
import "./SplashPage.css";
// import splashPhoto from "./splashPagePhoto.png";
import Contact from "../ContactSplash";
import SplashAbout from "../SplashAbout";
import SplashGallery from "../SplashGallery";
import InstagramGallery from "../InstagramGallery";
import Seo from "../Seo";

const SplashPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Seo
        title="Jasmine Landscape & Design | Orange County Landscaping - Irvine, Chino Hills & Yorba Linda"
        description="Custom landscape design & build serving Orange County since 1993, including Irvine, Chino Hills & Yorba Linda. Get a free landscaping quote today."
        path="/"
      />
      <div className="Splash-full-container">
        <div className="splashImage-container">
          <div className="welcomeDiv">
            <h1 className="welcomeh3">Welcome to Jasmine</h1>
            <div className="welcomeh3 secondh3">Landscape & Design</div>
            <p className="serviceAreaTagline">
              Orange County Landscaping - Serving Irvine, Chino Hills & Yorba Linda
            </p>
            <button
              onClick={() => {
                navigate("/contact");
              }}
              className="quote-button"
            >
              Get a FREE Quote
            </button>
            <p className="phoneNumberSplash">1 (949) 412-3153</p>
          </div>
        </div>
      </div>
      <Contact />
      <SplashAbout />
      <InstagramGallery />
      <SplashGallery />
    </>
  );
};

export default SplashPage;
